import initializeExperienceComponents from "./experience/index";
import initializeFaqScripts from "./components/faq";

$(() => {
    initializeExperienceComponents();
    initializeFaqScripts();
});
